import { createContext } from "react";

export const CarsContext = createContext(null);